import Vue from 'vue'
import App from './App.vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import router from './router'
import store from './store'
import Vuelidate from 'vuelidate'
import localizeFilter from './filters/localizeFilters'
import langFilter from './filters/langFilter'
import phoneFilter from './filters/phoneFilter'
import { ClientTable} from 'vue-tables-2';
import messagePlugin from './utils/message.plugin'

import { BootstrapVue, IconsPlugin, CollapsePlugin } from 'bootstrap-vue'
Vue.use(ClientTable);
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(CollapsePlugin)
Vue.use(Vuelidate)
Vue.use(VueAxios, axios)
Vue.use(messagePlugin)
Vue.filter('localize', localizeFilter)
Vue.filter('lang', langFilter)
Vue.filter('phone', phoneFilter)


require('./style/main.scss')



Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
